/*
 * @Author: cryi.liu
 * @Date: 2020-05-11 16:07:25
 * @LastEditTime: 2020-05-12 13:49:13
 * @Description: 权限服务 service
 */
import BaseService from './base.service';

export default class extends BaseService {
  async login(data = {}) {
    const url = this.API.auth.login;
    const result = await this.formPostOfBody(url, data);
    return result;
  }
}
